import { createAction, props } from '@ngrx/store';
import {LocationSetType} from '@emm/core/models/location-set-type.model';
import {SearchFilter} from '@emm/core/models/search-filter';

export enum LocationSetTypesAction {
    Load = '[Location Set Types Management] Load Location Set Types',
    LoadSuccess = '[Management API] Load Location Set Types Success',
    LoadFailure = '[Management API] Load Location Set Types Failure',
    Select = '[Location Set Types Management] Select Location Set Type',
    SearchLocationSetTypes = '[Location Set Types Management] Search Location Set Types',
    OpenAddDialog = '[Location Set Types Management] Open Add Location Set Type Dialog',
    Delete = '[Location Set Types Management] Delete Location Set Type',
    DeleteSuccess = '[Management API] Delete Location Set Type Success',
    DeleteFailure = '[Management API] Delete Location Set Type Failure',
    SelectFromLocationSets = '[Location Sets Management] Select Location Set Type',
    LoadFromLocationSets = '[Location Sets Management] Load Location Set Types From Location Sets',
    LoadFromLocationSetsSuccess = '[Management API] Load Location Set Types From Location Sets Success',
    LoadFromLocationSetsFailure = '[Management API] Load Location Set Types From Location Sets Failure'
}

export const LocationSetTypesActions = {
    load: createAction(LocationSetTypesAction.Load),
    loadSuccess: createAction(LocationSetTypesAction.LoadSuccess, props<{ locationSetTypes: LocationSetType[] }>()),
    loadFailure: createAction(LocationSetTypesAction.LoadFailure, props<{ error: any }>()),
    select: createAction(LocationSetTypesAction.Select, props<{ tag: string }>()),
    searchLocationSetTypes: createAction(
        LocationSetTypesAction.SearchLocationSetTypes,
        props<{ filter: SearchFilter }>()
    ),
    openAddDialog: createAction(LocationSetTypesAction.OpenAddDialog),
    delete: createAction(LocationSetTypesAction.Delete, props<{ locationSetType: LocationSetType }>()),
    deleteSuccess: createAction(LocationSetTypesAction.DeleteSuccess),
    deleteFailure: createAction(LocationSetTypesAction.DeleteFailure, props<{ error: any }>()),
    selectFromLocationSets: createAction(LocationSetTypesAction.SelectFromLocationSets, props<{ tag: string }>()),
    loadFromLocationSets: createAction(LocationSetTypesAction.LoadFromLocationSets),
    loadFromLocationSetsSuccess: createAction(
        LocationSetTypesAction.LoadFromLocationSetsSuccess,
        props<{ locationSetTypes: LocationSetType[] }>()
    ),
    loadFromLocationSetsFailure: createAction(
        LocationSetTypesAction.LoadFromLocationSetsFailure,
        props<{ error: any }>()
    ),
};

export const LocationSetTypeAsyncActions = {
    loadActions: [
        LocationSetTypesActions.load,
        LocationSetTypesActions.delete,
        LocationSetTypesActions.loadFromLocationSets
    ],
    successActions: [
        LocationSetTypesActions.loadSuccess,
        LocationSetTypesActions.deleteSuccess,
        LocationSetTypesActions.loadFromLocationSetsSuccess
    ],
    errorActions: [
        LocationSetTypesActions.loadFailure,
        LocationSetTypesActions.deleteFailure,
        LocationSetTypesActions.loadFromLocationSetsFailure
    ]
};
